export enum StatusDashboardQueries {
  StatusDashboard = 'statusDashboard',
  ProductStatuses = 'productStatuses',
  LevelElements = 'levelElements',
  Levels = 'levels',
  LevelTree = 'levelTree',
}
